import { render, staticRenderFns } from "./IndexData.vue?vue&type=template&id=6fa5d8ca&scoped=true"
import script from "./IndexData.vue?vue&type=script&lang=js"
export * from "./IndexData.vue?vue&type=script&lang=js"
import style0 from "./IndexData.vue?vue&type=style&index=0&id=6fa5d8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5d8ca",
  null
  
)

export default component.exports